import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrow_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M597.333 128A42.667 42.667 0 0 1 640 85.333h256A42.667 42.667 0 0 1 938.667 128v256a42.667 42.667 0 1 1-85.334 0V229.12L365.355 717.013a149.333 149.333 0 1 1-60.928-59.733l486.698-486.656H640a42.667 42.667 0 0 1-42.667-42.667zM170.667 789.333a64 64 0 1 0 128 0 64 64 0 0 0-128 0z"
    />
  </svg>
);
export default SvgArrowIcon;
